/**
 * Transparent Pricing Section - Mobile Slider Initialization
 * Exactly replicated from pricing-mobile-slider.js
 */

declare global {
    interface Window {
        Swiper: any;
        pricingSwiper?: any;
    }
}

export function initializePricingMobileSlider(containerElement: HTMLElement | null): void {
    // Only run on mobile screens
    if (window.innerWidth > 991) {
        return;
    }

    if (!containerElement) {
        return;
    }

    // Check if slider already exists
    if (containerElement.querySelector('.pricing-transparent__mobile-slider')) {
        return;
    }

    // Get the original row with cards
    const originalRow = containerElement.querySelector('.row.justify-content-center');
    if (!originalRow) return;

    // Clone the cards
    const cards = Array.from(originalRow.querySelectorAll('.col-xl-4'));
    if (cards.length === 0) return;

    // Create Swiper container structure
    const sliderContainer = document.createElement('div');
    sliderContainer.className = 'pricing-transparent__mobile-slider';

    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper-container pricing-mobile-swiper';

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    // Clone and wrap each card in a swiper-slide
    cards.forEach((card, index) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        // Clone the card content
        const cardClone = card.cloneNode(true) as HTMLElement;
        // Remove Bootstrap column classes from clone
        cardClone.classList.remove('col-xl-4', 'col-lg-6', 'col-md-6', 'wow', 'fadeInLeft', 'fadeInUp', 'fadeInRight');
        cardClone.style.width = '100%';

        // Re-attach click handlers to view-options buttons in cloned cards
        const viewOptionsButtons = cardClone.querySelectorAll('.view-options-btn');
        viewOptionsButtons.forEach(button => {
            // Determine which modal type based on button position/index
            let modalType = 'custom';
            if (index === 1) modalType = 'oil';
            else if (index === 2) modalType = 'oilFilter';
            
            // Remove existing React onClick handlers and add native click handler
            button.removeAttribute('onclick');
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if ((window as any).openPricingModal) {
                    (window as any).openPricingModal(modalType);
                }
            });
            // Also add touch support
            button.addEventListener('touchend', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if ((window as any).openPricingModal) {
                    (window as any).openPricingModal(modalType);
                }
            }, { passive: false });
        });

        slide.appendChild(cardClone);
        swiperWrapper.appendChild(slide);
    });

    swiperContainer.appendChild(swiperWrapper);

    // Add pagination
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    swiperContainer.appendChild(pagination);

    sliderContainer.appendChild(swiperContainer);

    // Insert after the section title
    const sectionTitle = containerElement.querySelector('.section-title');
    if (sectionTitle && sectionTitle.parentElement) {
        sectionTitle.parentElement.insertBefore(sliderContainer, originalRow);
    } else {
        const container = containerElement.querySelector('.container');
        if (container) {
            container.appendChild(sliderContainer);
        }
    }

    // Initialize Swiper - wait for it to be available
    const initSwiper = (): void => {
        if (typeof window.Swiper !== 'undefined') {
            const swiperElement = document.querySelector('.pricing-mobile-swiper');
            if (!swiperElement) return;

            // Check if already initialized
            if ((swiperElement as any).swiper) return;

            // Variables to track swipe direction
            let touchStartX = 0;
            let touchStartY = 0;

            const swiper = new window.Swiper('.pricing-mobile-swiper', {
                slidesPerView: 1.15,
                spaceBetween: 15,
                centeredSlides: false,
                loop: false,
                autoplay: false,
                pagination: {
                    el: '.pricing-transparent__mobile-slider .swiper-pagination',
                    clickable: true,
                },
                speed: 300,
                effect: 'slide',
                // Swiper touch settings - allow vertical scroll
                simulateTouch: true,
                touchRatio: 1,
                touchAngle: 45,
                threshold: 15,
                touchStartPreventDefault: false,
                touchMoveStopPropagation: false,
                preventClicks: false,
                preventClicksPropagation: false,
                // Custom handling for vertical vs horizontal scroll
                on: {
                    touchStart: function(_swiper: any, event: any) {
                        // Reset on each touch start
                        touchStartX = event.touches[0].clientX;
                        touchStartY = event.touches[0].clientY;
                    },
                    touchMove: function(swiper: any, event: any) {
                        if (!touchStartX || !touchStartY) return;

                        const diffX = Math.abs(event.touches[0].clientX - touchStartX);
                        const diffY = Math.abs(event.touches[0].clientY - touchStartY);

                        // If vertical movement is greater, disable slider and allow page scroll
                        if (diffY > diffX && diffY > 15) {
                            swiper.allowTouchMove = false;
                        } else if (diffX > diffY && diffX > 15) {
                            // Horizontal swipe - enable slider
                            swiper.allowTouchMove = true;
                        }
                    },
                    touchEnd: function(swiper: any) {
                        // Re-enable touch move for next interaction
                        swiper.allowTouchMove = true;
                        touchStartX = 0;
                        touchStartY = 0;
                    }
                }
            });

            window.pricingSwiper = swiper;
        } else {
            // Retry after a short delay if Swiper is not available
            setTimeout(initSwiper, 200);
        }
    };

    setTimeout(initSwiper, 200);
}

